import React, { useContext } from "react";
import { useNotifications } from "sprint-common-web";

import { CloudFileRejectionData } from "../../../../common/components/reject-cloud-file/CloudFileRejectionData";
import { RejectCloudFileDialogForm } from "../../../../common/components/reject-cloud-file/RejectCloudFileDialogForm";
import { useRejectCloudFile } from "../../../../common/components/reject-cloud-file/useRejectCloudFile";
import { CloudFileStatus } from "../../../../common/types/CloudFileStatus";
import { CloudFileListingContext } from "../../../CloudFileListingContext";

type RejectCloudFileListingDialogProps = {
    cloudFileId: string;
    onClose(): void;
};

export const RejectCloudFileListingDialog: React.VFC<RejectCloudFileListingDialogProps> = ({
    cloudFileId,
    onClose
}: RejectCloudFileListingDialogProps) => {
    const { rejectCloudFile } = useRejectCloudFile({ invalidationKey: cloudFileId });
    const { updateCloudFileStatus } = useContext(CloudFileListingContext);

    const { success: successNotification, error: errorNotification } = useNotifications();

    const reject = async (data: CloudFileRejectionData) => {
        try {
            await rejectCloudFile.mutateAsync({
                cloudFileId,
                reasonId: data.reason.id,
                details: data.details,
                courseOfActionId: data.courseOfAction?.id,
                fixedBillingId: data.fixedBilling?.id
            });

            updateCloudFileStatus(cloudFileId, CloudFileStatus.Rejected, {
                courseOfAction: data.courseOfAction.name,
                reason: data.reason.name,
                details: data.details,
                fixedBilling: data.fixedBilling?.name
            });

            onClose();

            successNotification("Rejection successful");
        } catch {
            errorNotification("Something went wrong while rejecting the cloud file");
        }
    };

    return (
        <RejectCloudFileDialogForm
            title="Reject cloud file"
            description="Are you sure you want to reject this cloud file?"
            onSubmit={reject}
            onClose={onClose}
        />
    );
};
